"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_CONFIG_PROVIDER_VALUES = exports.AI_CONFIG_PROVIDERS = exports.AI_CONFIG_TYPES = exports.AI_CONFIG_DEFINITIONS = exports.AI_CONFIG_CATEGORIES = void 0;
exports.isAiConfigType = isAiConfigType;
exports.suggestCanonicalAiConfigType = suggestCanonicalAiConfigType;
exports.getAiConfigTypeValidationMessage = getAiConfigTypeValidationMessage;
exports.assertAiConfigType = assertAiConfigType;
exports.getAiConfigCategory = getAiConfigCategory;
exports.isAiConfigProvider = isAiConfigProvider;
exports.AI_CONFIG_CATEGORIES = ['profile', 'business', 'ec', 'matching', 'other'];
function freezeUniqueDefinitions(definitions) {
    const types = new Set();
    for (const definition of definitions) {
        if (types.has(definition.type)) {
            throw new Error(`Duplicate AI config type: ${definition.type}`);
        }
        types.add(definition.type);
        Object.freeze(definition);
    }
    return Object.freeze(definitions);
}
exports.AI_CONFIG_DEFINITIONS = freezeUniqueDefinitions([
    {
        type: 'ai-speech-transcribe-realtime',
        label: 'ai-speech-transcribe-realtime',
        category: 'other',
        legacy: false,
        schemaId: 'ai-speech-transcribe-realtime',
    },
    {
        type: 'ai-action-speech-transcribe',
        label: 'ai-action-speech-transcribe',
        category: 'other',
        legacy: false,
        schemaId: 'ai-action-speech-transcribe',
    },
    {
        type: 'ai-action-translate-text',
        label: 'ai-action-translate-text',
        category: 'other',
        legacy: false,
        schemaId: 'ai-action-translate-text',
    },
    {
        type: 'creation-boolean-request',
        label: 'creation-boolean-request',
        category: 'matching',
        legacy: true,
        schemaId: 'creation-boolean-request',
    },
    { type: 'import-dt', label: 'dt-import-and-formatting', category: 'profile', legacy: false, schemaId: 'import-dt' },
    { type: 'enrich-dt', label: 'dt-enrichment', category: 'profile', legacy: false, schemaId: 'enrich-dt' },
    {
        type: 'enrich-dt-neylia-v2',
        label: 'dt-enrichment-neylia-v2',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-neylia-v2',
    },
    {
        type: 'enrich-dt-field-experience',
        label: 'dt-enrichment-experience-range',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-experience',
    },
    {
        type: 'enrich-dt-field-experience-basic',
        label: 'dt-enrichment-experience-range-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-experience-basic',
    },
    {
        type: 'enrich-dt-field-experience-advanced',
        label: 'dt-enrichment-experience-range-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-experience-advanced',
    },
    {
        type: 'enrich-dt-field-skills',
        label: 'dt-enrichment-skills',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-skills',
    },
    {
        type: 'enrich-dt-field-skills-basic',
        label: 'dt-enrichment-skills-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-skills-basic',
    },
    {
        type: 'enrich-dt-field-skills-advanced',
        label: 'dt-enrichment-skills-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-skills-advanced',
    },
    {
        type: 'enrich-dt-field-training',
        label: 'dt-enrichment-training',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-training',
    },
    {
        type: 'enrich-dt-field-training-basic',
        label: 'dt-enrichment-training-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-training-basic',
    },
    {
        type: 'enrich-dt-field-training-advanced',
        label: 'dt-enrichment-training-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-training-advanced',
    },
    {
        type: 'enrich-dt-field-languages',
        label: 'dt-enrichment-languages',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-languages',
    },
    {
        type: 'enrich-dt-field-languages-basic',
        label: 'dt-enrichment-languages-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-languages-basic',
    },
    {
        type: 'enrich-dt-field-languages-advanced',
        label: 'dt-enrichment-languages-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-languages-advanced',
    },
    {
        type: 'enrich-dt-field-activityAreas',
        label: 'dt-enrichment-activity-areas',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-activityAreas',
    },
    {
        type: 'enrich-dt-field-activityAreas-basic',
        label: 'dt-enrichment-activity-areas-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-activityAreas-basic',
    },
    {
        type: 'enrich-dt-field-activityAreas-advanced',
        label: 'dt-enrichment-activity-areas-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-activityAreas-advanced',
    },
    {
        type: 'enrich-dt-field-expertiseAreas',
        label: 'dt-enrichment-expertise-areas',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-expertiseAreas',
    },
    {
        type: 'enrich-dt-field-expertiseAreas-basic',
        label: 'dt-enrichment-expertise-areas-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-expertiseAreas-basic',
    },
    {
        type: 'enrich-dt-field-expertiseAreas-advanced',
        label: 'dt-enrichment-expertise-areas-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-expertiseAreas-advanced',
    },
    { type: 'enrich-dt-field-tools', label: 'dt-enrichment-tools', category: 'profile', legacy: false, schemaId: 'enrich-dt-field-tools' },
    {
        type: 'enrich-dt-field-tools-basic',
        label: 'dt-enrichment-tools-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-tools-basic',
    },
    {
        type: 'enrich-dt-field-tools-advanced',
        label: 'dt-enrichment-tools-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-tools-advanced',
    },
    {
        type: 'enrich-dt-field-references',
        label: 'dt-enrichment-references',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references',
    },
    {
        type: 'enrich-dt-field-references-basic',
        label: 'dt-enrichment-references-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-basic',
    },
    {
        type: 'enrich-dt-field-references-advanced',
        label: 'dt-enrichment-references-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-advanced',
    },
    {
        type: 'enrich-dt-field-references-identity',
        label: 'enrich-dt-field-references-identity',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-references-identity',
    },
    {
        type: 'enrich-dt-field-references-identity-basic',
        label: 'enrich-dt-field-references-identity-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-identity-basic',
    },
    {
        type: 'enrich-dt-field-references-identity-advanced',
        label: 'enrich-dt-field-references-identity-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-identity-advanced',
    },
    {
        type: 'enrich-dt-field-references-identity-academic-personal-basic',
        label: 'enrich-dt-field-references-identity-academic-personal-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-identity-academic-personal-basic',
    },
    {
        type: 'enrich-dt-field-references-identity-academic-personal-advanced',
        label: 'enrich-dt-field-references-identity-academic-personal-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-identity-academic-personal-advanced',
    },
    {
        type: 'enrich-dt-field-references-content-academic-personal-basic',
        label: 'enrich-dt-field-references-content-academic-personal-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-content-academic-personal-basic',
    },
    {
        type: 'enrich-dt-field-references-content-academic-personal-advanced',
        label: 'enrich-dt-field-references-content-academic-personal-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-content-academic-personal-advanced',
    },
    {
        type: 'enrich-dt-field-references-content',
        label: 'enrich-dt-field-references-content',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-references-content',
    },
    {
        type: 'enrich-dt-field-references-content-basic',
        label: 'enrich-dt-field-references-content-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-content-basic',
    },
    {
        type: 'enrich-dt-field-references-content-advanced',
        label: 'enrich-dt-field-references-content-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-content-advanced',
    },
    {
        type: 'enrich-dt-field-references-splitter',
        label: 'enrich-dt-field-references-splitter',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-references-splitter',
    },
    {
        type: 'enrich-dt-field-references-splitter-basic',
        label: 'enrich-dt-field-references-splitter-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-splitter-basic',
    },
    {
        type: 'enrich-dt-field-references-splitter-advanced',
        label: 'enrich-dt-field-references-splitter-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-splitter-advanced',
    },
    {
        type: 'enrich-dt-field-references-dispatcher-basic',
        label: 'enrich-dt-field-references-dispatcher-basic',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-dispatcher-basic',
    },
    {
        type: 'enrich-dt-field-references-dispatcher-advanced',
        label: 'enrich-dt-field-references-dispatcher-advanced',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-dispatcher-advanced',
    },
    { type: 'enrich-dt-mini', label: 'dt-enrichment-mini', category: 'profile', legacy: false, schemaId: 'enrich-dt-mini' },
    {
        type: 'enrich-dt-basic-mini',
        label: 'dt-enrichment-basic-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-basic-mini',
    },
    {
        type: 'enrich-dt-field-experience-mini',
        label: 'dt-enrichment-experience-range-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-experience-mini',
    },
    {
        type: 'enrich-dt-field-experience-basic-mini',
        label: 'dt-enrichment-experience-range-basic-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-experience-basic-mini',
    },
    {
        type: 'enrich-dt-field-skills-mini',
        label: 'dt-enrichment-skills-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-skills-mini',
    },
    {
        type: 'enrich-dt-field-training-mini',
        label: 'dt-enrichment-training-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-training-mini',
    },
    {
        type: 'enrich-dt-field-training-basic-mini',
        label: 'dt-enrichment-training-basic-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-training-basic-mini',
    },
    {
        type: 'enrich-dt-field-languages-mini',
        label: 'dt-enrichment-languages-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-languages-mini',
    },
    {
        type: 'enrich-dt-field-languages-basic-mini',
        label: 'dt-enrichment-languages-basic-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-languages-basic-mini',
    },
    {
        type: 'enrich-dt-field-activityAreas-mini',
        label: 'dt-enrichment-activity-areas-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-activityAreas-mini',
    },
    {
        type: 'enrich-dt-field-expertiseAreas-mini',
        label: 'dt-enrichment-expertise-areas-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-expertiseAreas-mini',
    },
    {
        type: 'enrich-dt-field-expertiseAreas-basic-mini',
        label: 'dt-enrichment-expertise-areas-basic-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-expertiseAreas-basic-mini',
    },
    {
        type: 'enrich-dt-field-tools-mini',
        label: 'dt-enrichment-tools-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-tools-mini',
    },
    {
        type: 'enrich-dt-field-tools-basic-mini',
        label: 'dt-enrichment-tools-basic-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-tools-basic-mini',
    },
    {
        type: 'enrich-dt-field-references-mini',
        label: 'dt-enrichment-references-mini',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-dt-field-references-mini',
    },
    {
        type: 'enrich-dt-field-references-basic-mini',
        label: 'dt-enrichment-references-basic-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-references-basic-mini',
    },
    {
        type: 'enrich-dt-field-references-advanced-mini',
        label: 'dt-enrichment-references-advanced-mini',
        category: 'profile',
        legacy: true,
        schemaId: 'enrich-dt-field-references-advanced-mini',
    },
    { type: 'enrich-dt-basic', label: 'cv-import-and-formatting', category: 'profile', legacy: false, schemaId: 'enrich-dt-basic' },
    { type: 'enrich-company', label: 'company-enrichment', category: 'business', legacy: true, schemaId: 'enrich-company' },
    {
        type: 'enrich-company-field-country',
        label: 'company-enrichment-country',
        category: 'business',
        legacy: true,
        schemaId: 'enrich-company-field-country',
    },
    {
        type: 'enrich-company-field-expertiseArea',
        label: 'company-enrichment-expertise-area',
        category: 'business',
        legacy: true,
        schemaId: 'enrich-company-field-expertiseArea',
    },
    {
        type: 'enrich-company-field-parentCompany',
        label: 'company-enrichment-parent-company',
        category: 'business',
        legacy: true,
        schemaId: 'enrich-company-field-parentCompany',
    },
    {
        type: 'enrich-opportunity',
        label: 'job-description-enrichment',
        category: 'business',
        legacy: false,
        schemaId: 'enrich-opportunity',
    },
    {
        type: 'enrich-opportunity-field-tools',
        label: 'job-description-enrichment-tools',
        category: 'business',
        legacy: false,
        schemaId: 'enrich-opportunity-field-tools',
    },
    {
        type: 'enrich-opportunity-field-activityAreas',
        label: 'job-description-enrichment-activityAreas',
        category: 'business',
        legacy: false,
        schemaId: 'enrich-opportunity-field-activityAreas',
    },
    {
        type: 'enrich-opportunity-field-expertiseArea',
        label: 'job-description-enrichment-expertiseArea',
        category: 'business',
        legacy: false,
        schemaId: 'enrich-opportunity-field-expertiseArea',
    },
    {
        type: 'enrich-opportunity-field-place',
        label: 'job-description-enrichment-place',
        category: 'business',
        legacy: false,
        schemaId: 'enrich-opportunity-field-place',
    },
    { type: 'enrich-entity-sheet', label: 'entity-sheet-enrichment', category: 'profile', legacy: false, schemaId: 'enrich-entity-sheet' },
    {
        type: 'enrich-entity-sheet-field-informations-civility',
        label: 'entity-sheet-enrichment-informations-civility',
        category: 'profile',
        legacy: false,
        schemaId: 'enrich-entity-sheet-field-informations-civility',
    },
    {
        type: 'import-opportunity',
        label: 'job-description-import-and-formatting',
        category: 'business',
        legacy: false,
        schemaId: 'import-opportunity',
    },
    { type: 'interview-preparation', label: 'interview-preparation', category: 'ec', legacy: false, schemaId: 'interview-preparation' },
    {
        type: 'interview-preparation-criteria',
        label: 'interview-preparation-criteria',
        category: 'ec',
        legacy: false,
        schemaId: 'interview-preparation-criteria',
    },
    {
        type: 'interview-preparation-evaluation',
        label: 'interview-preparation-evaluation',
        category: 'ec',
        legacy: false,
        schemaId: 'interview-preparation-evaluation',
    },
    {
        type: 'interview-preparation-field-activityAreas',
        label: 'interview-preparation-activityAreas',
        category: 'ec',
        legacy: false,
        schemaId: 'interview-preparation-field-activityAreas',
    },
    {
        type: 'interview-preparation-field-commutingTimeRating',
        label: 'interview-preparation-commutingTimeRating',
        category: 'ec',
        legacy: false,
        schemaId: 'interview-preparation-field-commutingTimeRating',
    },
    { type: 'profile-matching', label: 'profile-matching', category: 'matching', legacy: false, schemaId: 'profile-matching' },
    {
        type: 'profile-matching-boolean-request',
        label: 'profile-matching-boolean-request',
        category: 'matching',
        legacy: false,
        schemaId: 'profile-matching-boolean-request',
    },
    {
        type: 'profile-matching-scoring-rubric',
        label: 'profile-matching-scoring-rubric',
        category: 'matching',
        legacy: false,
        schemaId: 'profile-matching-scoring-rubric',
    },
    {
        type: 'candidate-opportunity-scoring',
        label: 'candidate-opportunity-scoring',
        category: 'business',
        legacy: false,
        schemaId: 'candidate-opportunity-scoring',
    },
]);
const AI_CONFIG_DEFINITION_BY_TYPE = new Map(exports.AI_CONFIG_DEFINITIONS.map((definition) => [definition.type, definition]));
exports.AI_CONFIG_TYPES = Object.freeze(exports.AI_CONFIG_DEFINITIONS.map(({ type }) => type));
const AI_CONFIG_TYPE_SET = new Set(exports.AI_CONFIG_TYPES);
const AI_CONFIG_TYPE_BY_LOWER_CASE = new Map(exports.AI_CONFIG_TYPES.map((type) => [type.toLowerCase(), type]));
function isAiConfigType(value) {
    return AI_CONFIG_TYPE_SET.has(value);
}
function suggestCanonicalAiConfigType(value) {
    return AI_CONFIG_TYPE_BY_LOWER_CASE.get(value.toLowerCase());
}
function getAiConfigTypeValidationMessage(value) {
    const suggestion = suggestCanonicalAiConfigType(value);
    return suggestion ? `Invalid AI config type "${value}". Did you mean "${suggestion}"?` : `Unknown AI config type "${value}"`;
}
function assertAiConfigType(value) {
    if (!isAiConfigType(value)) {
        throw new RangeError(getAiConfigTypeValidationMessage(value));
    }
}
function getAiConfigCategory(value) {
    const definition = AI_CONFIG_DEFINITION_BY_TYPE.get(value);
    if (definition) {
        return definition.category;
    }
    // Compatibility for deployed or future types that are not catalogued yet.
    if (/dt|cv|entity-sheet/i.test(value)) {
        return 'profile';
    }
    if (/opportunity|prospecting/i.test(value)) {
        return 'business';
    }
    if (/interview-preparation/i.test(value)) {
        return 'ec';
    }
    if (/matching/i.test(value)) {
        return 'matching';
    }
    return 'other';
}
const MISTRAL_DEFAULT_OPTIONS = Object.freeze({
    temperature: null,
    top_p: 1,
    max_tokens: null,
    stream: false,
    presence_penalty: 0,
    frequency_penalty: 0,
    parallel_tool_calls: true,
    random_seed: null,
    safe_prompt: false,
});
exports.AI_CONFIG_PROVIDERS = Object.freeze([
    Object.freeze({
        value: 'mistral',
        label: 'Mistral AI',
        options: MISTRAL_DEFAULT_OPTIONS,
    }),
    Object.freeze({
        value: 'openai',
        label: 'OpenAI',
    }),
]);
exports.AI_CONFIG_PROVIDER_VALUES = Object.freeze(exports.AI_CONFIG_PROVIDERS.map(({ value }) => value));
const AI_CONFIG_PROVIDER_SET = new Set(exports.AI_CONFIG_PROVIDER_VALUES);
function isAiConfigProvider(value) {
    return AI_CONFIG_PROVIDER_SET.has(value);
}
